export enum CoffeeCodeStatus {
  READY = 'READY',
  USED = 'USED',
  EXPIRED = 'EXPIRED'
}
